const ECGRecipe = {
    $type$: 'Recipe',
    name: 'Electrocardiogram',
    rule: [
        {
            itemprop: 'typeDescription',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'voltageMeasurements',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'startTimestamp',
            itemtype: { type: 'number' },
            optional: true
        },
        {
            itemprop: 'samplingFrequencyHz',
            itemtype: { type: 'number' },
            optional: true
        },
        {
            itemprop: 'endTimestamp',
            itemtype: { type: 'number' },
            optional: true
        },
        {
            itemprop: 'classification',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'averageHeartRateBPM',
            itemtype: { type: 'number' },
            optional: true
        },
        {
            itemprop: 'symptoms',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'readings',
            itemtype: { type: 'stringifiable' }
        }
    ]
};
const ECGRecipes = [ECGRecipe];
export default ECGRecipes;
//# sourceMappingURL=ECGRecipes.js.map